const Page404 = () => import('@/commons/error-pages/404.vue')
const Page403 = () => import('@/commons/error-pages/403.vue')
const Page500 = () => import('@/commons/error-pages/500.vue')


export const errorRoutes = [
  { path: '/404', component: Page404 },
  { path: '/403', component: Page403 },
  { path: '/500', component: Page500 },
  { path: '/:catchAll(.*)', component: Page404 },
]
